module.exports = __webpack_public_path__ + "img/20220624145225.d63929a2.png";